module.exports = __webpack_public_path__ + "static/simple-39cc38d2e3db62a9bc7c1dec45b28204.png";